import { ObservableArray, View } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { DummyTablePlaceHolderComponentElement } from "./dummyTablePlaceHolderComponent-viewModel";
import { TdDecoratorViewModel } from "./tdDecorator/tdDecorator-viewModel";

export class DummyTablePlaceHolderComponentView extends FormBuilderComponentView<DummyTablePlaceHolderComponentElement>{
    GetViewUniqueId(): string {
        return "V-F987A10C-1330-4725-A966-9652386E6228"
    }
    loadHtml(): string {
        let element = require('./dummyTablePlaceHolderComponent.html').default;
        let style = require('./dummyTablePlaceHolderComponent.less');
        return element;
    }
    constructor() {
       super();
    }

    public set tds(v: ObservableArray<TdDecoratorViewModel>) { this._tds = v; } public get tds(): ObservableArray<TdDecoratorViewModel> { return this._tds;} private _tds: ObservableArray<TdDecoratorViewModel>;

}
